import React, { useEffect } from 'react';
import { useAuthStore } from '@/store/authStore';
import { useNavigate } from 'react-router-dom';

interface WorkspaceGuardProps {
  children: React.ReactNode;
}

/**
 * A component guard that checks if the user has workspaces but hasn't selected one.
 * If so, it redirects to the onboarding page.
 * This should wrap routes/components that require an active workspace.
 */
export function WorkspaceGuard({ children }: WorkspaceGuardProps) {
  const navigate = useNavigate();
  const { currentWorkspace } = useAuthStore((state) => ({
    workspaces: state.workspaces,
    currentWorkspace: state.currentWorkspace,
  }));

  useEffect(() => {
    // Condition: User is logged in (implied by reaching this guard),
    // but hasn't selected a workspace yet.
    if (!currentWorkspace) {
      console.log('WorkspaceGuard: No current workspace selected, redirecting to /onboarding');
      navigate('/onboarding');
    }
  }, [currentWorkspace, navigate]);

  // Only render children if workspace is selected
  if (currentWorkspace) {
    return <>{children}</>;
  }

  // Return null during redirect
  return null;
}
